module.exports = __webpack_public_path__ + "img/accesories.e539e461.png";